export type ColumnViewPref = {
  order: string[]
  hidden: string[]
}

const sessionViews = new Map<string, ColumnViewPref | null>()

function sessionKey(userId: string, tableKey: string): string {
  return `${userId}\0${tableKey}`
}

export function rememberSessionColumnView(
  userId: string,
  tableKey: string,
  view: ColumnViewPref | null
): void {
  if (!userId || !tableKey) return
  sessionViews.set(sessionKey(userId, tableKey), view)
}

/** undefined means this session has not saved a layout for the table. null means it was cleared. */
export function readSessionColumnView(
  userId: string,
  tableKey: string
): ColumnViewPref | null | undefined {
  if (!userId || !tableKey) return undefined
  const key = sessionKey(userId, tableKey)
  if (!sessionViews.has(key)) return undefined
  return sessionViews.get(key) ?? null
}

export function findColumnView(columnViews: unknown, tableKey: string): ColumnViewPref | null {
  if (!Array.isArray(columnViews) || !tableKey) return null
  for (const entry of columnViews) {
    if (!entry || typeof entry !== "object") continue
    const record = entry as { tableKey?: unknown; order?: unknown; hidden?: unknown }
    if (record.tableKey !== tableKey || !Array.isArray(record.order)) continue
    const order = record.order.filter((id): id is string => typeof id === "string" && id.length > 0)
    if (order.length === 0) return null
    const hidden = Array.isArray(record.hidden)
      ? record.hidden.filter((id): id is string => typeof id === "string" && id.length > 0)
      : []
    return { order, hidden }
  }
  return null
}
